/**
 * Collapsible text section: toggle expand/collapse and update button label.
 * Uses data-collapsible-text-toggle on the button and data-expand-label / data-collapse-label on the wrapper.
 */
function initCollapsibleText(container = document) {
  container.querySelectorAll('.collapsible-text').forEach((wrapper) => {
    const toggle = wrapper.querySelector('[data-collapsible-text-toggle]');
    if (!toggle) return;

    const expandLabel = wrapper.dataset.expandLabel || 'Show more';
    const collapseLabel = wrapper.dataset.collapseLabel || 'Show less';

    toggle.addEventListener('click', () => {
      const isExpanded = wrapper.classList.toggle('is-expanded');
      toggle.textContent = isExpanded ? collapseLabel : expandLabel;
      toggle.setAttribute('aria-expanded', isExpanded);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initCollapsibleText());
document.addEventListener('shopify:section:load', (event) => initCollapsibleText(event.target));
